export default (value) => ({
  name: value,
  value,
})
